import { getAdminApiUrl } from '@adsk/acs-sc-web-platform-api';
import { PRODUCT_IDS } from '@adsk/alloy-provider';
import {
  FolderIcon,
  CollaborationIcon,
  BoxIcon,
  PercentIcon,
  HammerIcon,
  MoneyIcon,
  DocumentCrosshairIcon,
} from '@adsk/alloy-react-icon';
import { getConstructionApiUrl } from '@common/utils';

const PRODUCT_SETTINGS_URL_MAPPINGS = {
  [PRODUCT_IDS.DOCS]: '/docs/settings/projects',
  [PRODUCT_IDS.DESIGN_COLLABORATION]: '/dc/settings/projects',
  [PRODUCT_IDS.MODEL_COORDINATION]: '/model/settings/projects',
  [PRODUCT_IDS.QUANTIFY]: '/quantify/settings/projects',
  [PRODUCT_IDS.BUILD]: '/build/settings/projects',
  [PRODUCT_IDS.COST]: '/cost/settings/projects',
  [PRODUCT_IDS.AUTOSPECS]: '/autospecs/settings/projects',
};

const PRODUCT_ICON_MAPPINGS = {
  [PRODUCT_IDS.DOCS]: FolderIcon,
  [PRODUCT_IDS.DESIGN_COLLABORATION]: CollaborationIcon,
  [PRODUCT_IDS.MODEL_COORDINATION]: BoxIcon,
  [PRODUCT_IDS.QUANTIFY]: PercentIcon,
  [PRODUCT_IDS.BUILD]: HammerIcon,
  [PRODUCT_IDS.COST]: MoneyIcon,
  [PRODUCT_IDS.AUTOSPECS]: DocumentCrosshairIcon,
};

// ACSPA-1738: Docs has to be hidden for GA release
const HIDDEN_PRODUCTS = [
  PRODUCT_IDS.INSIGHT,
  PRODUCT_IDS.DOCS,
  PRODUCT_IDS.TAKEOFF,
  PRODUCT_IDS.PROJECT_ADMINISTRATION,
];

const buildProductSettingsUrl = (productId, projectId) =>
  `${PRODUCT_SETTINGS_URL_MAPPINGS[productId]}/${projectId}`;

export const buildGetProjectRequest = (
  projectId,
  useConstructionApi = false
) => {
  const url = useConstructionApi ? getConstructionApiUrl() : getAdminApiUrl();

  return `${url}/v1/projects/${projectId}`;
};

export const computeAdminAccessProducts = (products = [], projectId) =>
  products
    .filter(
      ({ accessLevels, key }) =>
        accessLevels.productAdministrator === true &&
        !HIDDEN_PRODUCTS.includes(key)
    )
    .map(({ key, name: label }) => ({
      key,
      label,
      icon: PRODUCT_ICON_MAPPINGS[key],
      url: buildProductSettingsUrl(key, projectId),
    }));
